import React from 'react';
import './App.css';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { Toaster } from './components/ui/toaster';
import Header from './components/Header';
import Hero from './components/Hero';
import About from './components/About';
import HowWeHelp from './components/HowWeHelp';
import Impact from './components/Impact';
import Communities from './components/Communities';
import HelloSupport from './components/HelloSupport';
import InstagramFeed from './components/InstagramFeed';
import GetInvolved from './components/GetInvolved';
import Donate from './components/Donate';
import Contact from './components/Contact';
import Footer from './components/Footer';
import DonateSuccess from './components/DonateSuccess';
import DonateCancel from './components/DonateCancel';

const Home = () => (
  <div className="bg-white text-slate-900">
    <Header />
    <main>
      <Hero />
      <About />
      <HowWeHelp />
      <Impact />
      <Communities />
      <HelloSupport />
      <GetInvolved />
      <Donate />
      <InstagramFeed />
      <Contact />
    </main>
    <Footer />
  </div>
);

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/donate/success" element={<DonateSuccess />} />
          <Route path="/donate/cancel" element={<DonateCancel />} />
        </Routes>
      </BrowserRouter>
      <Toaster />
    </div>
  );
}

export default App;
